module.exports = fox._r("fonts/simplifica.ttf", __webpack_public_path__ + "fonts/qrc--6E.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/simplifica.ttf
// module id = 46
// module chunks = 4